import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Transition as _Transition, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "vab-screen-lock"
};
const _hoisted_2 = {
  class: "vab-screen-lock-content"
};
const _hoisted_3 = {
  class: "vab-screen-lock-content-title"
};
const _hoisted_4 = {
  class: "vab-screen-lock-content-form"
};
import { useUserStore } from '@/store/modules/user';
import { useSettingsStore } from '@/store/modules/settings';
import { translate } from '@/i18n';

import { storeToRefs } from 'pinia';
import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const vFocus = {
      mounted(el) {
        el.querySelector('input')?.focus();
      }
    };
    const userStore = useUserStore();
    const {
      avatar
    } = storeToRefs(userStore);
    const settingsStore = useSettingsStore();
    const {
      theme,
      lock,
      title
    } = storeToRefs(settingsStore);
    const {
      handleLock: _handleLock,
      handleUnLock: _handleUnLock
    } = settingsStore;
    const background = ref('https://fastly.jsdelivr.net/gh/' + 'chuzh' + 'ixin/image/vab-im' + 'age-lock/' + `${Math.round(Math.random() * 31)}.jpg`);
    const randomBackground = () => {
      background.value = 'https://fastly.jsdelivr.net/gh/' + 'chuzh' + 'ixin/image/vab-im' + 'age-lock/' + `${Math.round(Math.random() * 31)}.jpg`;
    };
    const validatePass = (rule, value, callback) => {
      if (value === '' || value !== '123456') {
        callback(new Error('请输入正确的密码'));
      } else {
        callback();
      }
    };
    const formRef = ref();
    const form = ref({
      password: '123456'
    });
    const rules = {
      password: [{
        validator: validatePass,
        trigger: 'blur'
      }]
    };
    let lockIcon = true;
    const handleUnLock = () => {
      formRef.value.validate(async valid => {
        if (valid) {
          lockIcon = false;
          setTimeout(async () => {
            await _handleUnLock();
            lockIcon = true;
            await randomBackground();
            const el = document.querySelector('.vab-side-bar');
            if (el) el.removeAttribute('style');
          }, 500);
        }
      });
    };
    const handleLock = () => {
      _handleLock();
      const el = document.querySelector('.vab-side-bar');
      if (el) el.style.display = 'none';
    };
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(theme).showLock ? (_openBlock(), _createBlock(_component_vab_icon, {
        key: 0,
        icon: "lock-line",
        onClick: handleLock
      })) : _createCommentVNode("", true), _unref(theme).showLock ? (_openBlock(), _createBlock(_Transition, {
        key: 1,
        mode: "out-in",
        name: "fade-transform"
      }, {
        default: _withCtx(() => [_unref(lock) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
          class: "vab-screen-lock-background",
          style: _normalizeStyle({
            background: `fixed url(${_unref(background)}) center`,
            backgroundSize: '100% 100%',
            filter: 'blur(10px)'
          })
        }, null, 4), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_avatar, {
          size: 180,
          src: _unref(avatar)
        }, null, 8, ["src"]), _createVNode(_component_vab_icon, {
          icon: _unref(lockIcon) ? 'lock-line' : 'lock-unlock-line'
        }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(_unref(title)) + " " + _toDisplayString(_unref(translate)('屏幕已锁定')), 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: _unref(form),
          rules: rules,
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "",
            "label-width": 0,
            prop: "password"
          }, {
            default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_input, {
              modelValue: _unref(form).password,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).password = $event),
              autocomplete: "off",
              placeholder: "请输出密码123456",
              type: "password"
            }, {
              suffix: _withCtx(() => [_createVNode(_component_el_button, {
                "native-type": "submit",
                type: "primary",
                onClick: handleUnLock
              }, {
                default: _withCtx(() => [_createVNode(_component_vab_icon, {
                  icon: _unref(lockIcon) ? 'lock-line' : 'lock-unlock-line'
                }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(_unref(translate)('解锁')), 1)]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])), [[vFocus]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]), _createElementVNode("span", {
          onClick: randomBackground
        }, _toDisplayString(_unref(translate)('切换壁纸')), 1)])])) : _createCommentVNode("", true)]),
        _: 1
      })) : _createCommentVNode("", true)], 64);
    };
  }
});